import { cleanObject } from 'src/libs/helper'
import { SamlIdpResponse, SamlIdpEntity, SamlIdpFormEntity, SamlIdpRequest } from 'src/types'

export const SamlIdpTranslator = {
  toEntity: (response: SamlIdpResponse): SamlIdpEntity => {
    return {
      samlIdp: {
        id: response.samlIdp?.id ?? undefined,
        idpSignout: response.samlIdp?.idpSignout ?? undefined,
        metadataFile: response.samlIdp?.metadataFile ?? undefined,
        metadataFileName: response.samlIdp?.metadataFileName ?? undefined,
        metadataURL: response.samlIdp?.metadataURL ?? undefined,
        attributeMapping: {
          email: response.samlIdp?.attributeMapping.email ?? undefined,
          name: response.samlIdp?.attributeMapping.name ?? undefined,
          department: response.samlIdp?.attributeMapping.department ?? undefined,
        },
      },
      assertionConsumerServiceURL: response.assertionConsumerServiceURL,
      serviceProviderURN: response.serviceProviderURN,
    }
  },

  toFormEntity: (entity: SamlIdpEntity): SamlIdpFormEntity => {
    return {
      idpSignout: entity.samlIdp.idpSignout ?? false,
      metadataSourceType: entity.samlIdp.metadataURL ? 'metadataURL' : 'metadataFile',
      metadata: {
        metadataFile: entity.samlIdp.metadataFile,
        metadataFileName: entity.samlIdp.metadataFileName,
        metadataURL: entity.samlIdp.metadataURL,
      },
      attributeMapping: {
        email: entity.samlIdp.attributeMapping.email ?? '',
        name: entity.samlIdp.attributeMapping.name,
        department: entity.samlIdp.attributeMapping.department,
      },
    }
  },

  toSamlIdpRequest: (formEntity: SamlIdpFormEntity): SamlIdpRequest => {
    const metadataFile =
      formEntity.metadataSourceType === 'metadataFile'
        ? formEntity.metadata.metadataFile
        : undefined
    const metadataFileName =
      formEntity.metadataSourceType === 'metadataFile'
        ? formEntity.metadata.metadataFileName
        : undefined
    const metadataURL =
      formEntity.metadataSourceType === 'metadataURL' ? formEntity.metadata.metadataURL : undefined

    const baseAttributeMapping = {
      email: formEntity.attributeMapping.email,
    }
    const optionalAttributeMapping = {
      name:
        formEntity.attributeMapping.name && formEntity.attributeMapping.name !== ''
          ? formEntity.attributeMapping.name
          : undefined,
      department:
        formEntity.attributeMapping.department && formEntity.attributeMapping.department !== ''
          ? formEntity.attributeMapping.department
          : undefined,
    }
    const attributeMapping = {
      ...baseAttributeMapping,
      ...cleanObject(optionalAttributeMapping), // undefinedのプロパティは除去
    }

    return {
      idpSignout: formEntity.idpSignout,
      metadata: {
        metadataFile,
        metadataFileName,
        metadataURL,
      },
      attributeMapping,
    }
  },
} as const
